export interface IExcelFile {
  id?: number;
  fileContentType?: string;
  file?: any;
  tableName?: string;
}

export const defaultValue: Readonly<IExcelFile> = {};
